import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

import { MainBannerActionTypes } from "./constants";
import {
  addMainBanner,
  deleteMainBanner,
  getMainBannerApi,
  updateMainBanner,
} from "../../helpers/api/main_banner";
import {
  getMainBanner,
  mainBannerApiResponseError,
  mainBannerApiResponseSuccess,
} from "./actions";

interface MainBannerData {
  payload: {
    id: number;
    file: any;
    head: string;
    subhead: string;
    head_ar: string;
    subhead_ar: string;
    title_text: string;
    title_text_ar: string;
  };
  type: string;
}

function* createMainBannerr({
  payload: {
    title_text,
    title_text_ar,
    file,
    head,
    subhead,
    head_ar,
    subhead_ar,
  },
  type,
}: MainBannerData): SagaIterator {
  try {
    const response = yield call(addMainBanner, {
      title_text,
      title_text_ar,
      file,
      head,
      subhead,
      head_ar,
      subhead_ar,
    });
    
    

    const mainBannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      mainBannerApiResponseSuccess(
        MainBannerActionTypes.CREATE_MAIN_BANNER,
        mainBannerData
      )
    );
    yield put(getMainBanner());
  } catch (error: any) {
    yield put(
      mainBannerApiResponseError(
        MainBannerActionTypes.CREATE_MAIN_BANNER,
        error
      )
    );
  }
}

function* updateMainBannerr({
  payload: {
    id,
    title_text,
    title_text_ar,
    file,
    head,
    subhead,
    head_ar,
    subhead_ar,
  },
}: MainBannerData): SagaIterator {
  try {
    const response = yield call(updateMainBanner, id, {
      title_text,
      title_text_ar,
      file,
      head,
      subhead,
      head_ar,
      subhead_ar,
    });
    const mainBannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      mainBannerApiResponseSuccess(
        MainBannerActionTypes.UPDATE_MAIN_BANNER,
        mainBannerData
      )
    );
    yield put(getMainBanner());
  } catch (error: any) {
    yield put(
      mainBannerApiResponseError(
        MainBannerActionTypes.UPDATE_MAIN_BANNER,
        error
      )
    );
  }
}

function* getMainBannerr(): SagaIterator {
  try {
    const response = yield call(getMainBannerApi);

    const MainBannerData = response?.data?.data;

    yield put(
      mainBannerApiResponseSuccess(
        MainBannerActionTypes.GET_MAIN_BANNER,
        MainBannerData
      )
    );
  } catch (error: any) {
    yield put(
      mainBannerApiResponseError(MainBannerActionTypes.GET_MAIN_BANNER, error)
    );
  }
}

function* deleteMainBannerr({ payload: { id } }: MainBannerData): SagaIterator {
  try {
    const response = yield call(deleteMainBanner, id);
    const mainBannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      mainBannerApiResponseSuccess(
        MainBannerActionTypes.DELETE_MAIN_BANNER,
        mainBannerData
      )
    );
    yield put(getMainBanner());
  } catch (error: any) {
    yield put(
      mainBannerApiResponseError(
        MainBannerActionTypes.DELETE_MAIN_BANNER,
        error
      )
    );
  }
}

export function* watchCreateMainBanner() {
  yield takeEvery(MainBannerActionTypes.CREATE_MAIN_BANNER, createMainBannerr);
}
export function* watchUpdateMainBanner() {
  yield takeEvery(MainBannerActionTypes.UPDATE_MAIN_BANNER, updateMainBannerr);
}
export function* watchGetMainBanner() {
  yield takeEvery(MainBannerActionTypes.GET_MAIN_BANNER, getMainBannerr);
}

export function* watchDeleteMainBanner() {
  yield takeEvery(MainBannerActionTypes.DELETE_MAIN_BANNER, deleteMainBannerr);
}

function* MainBannerSaga() {
  yield all([
    fork(watchCreateMainBanner),
    fork(watchUpdateMainBanner),
    fork(watchDeleteMainBanner),
    fork(watchGetMainBanner),
  ]);
}

export default MainBannerSaga;
